import React, { Fragment, useContext, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { StoreContext } from 'pages/_app';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import Cart from 'components/Cart';
import AddressConfirmationModal from 'components/AddressConfirmationModal';
import moment from 'moment-timezone';
import { useRouter } from 'next/router';

function CartMobile({ restaurantDetail }) {
  const store = useContext(StoreContext);
  const cartStore = toJS(store?.cartStore);
  const { cartMobile, cart } = cartStore;
  const { userLogin, address, selectedTime } = store.userStore;
  const [addressConfirmationModal, setAddressConfirmationModal] = useState(false);
  const [addressConfirm, setAddressConfirm] = useState(userLogin ? true : false);
  const router = useRouter();
  return (
    <Transition appear show={cartMobile} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => store?.cartStore?.setCartMobile(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed top-0 right-0 left-0 md:inset-0">
          <div className="flex min-h-screen max-h-screen overflow-scroll md:min-h-full md:items-center md:justify-center md:p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="flex flex-col flex-1 w-full md:w-5/12 transform md:rounded-2xl bg-white py-5 px-2 text-left align-middle shadow-xl transition-all">
                <div className="flex justify-end px-4">
                  <button
                    type="button"
                    onClick={() => store?.cartStore?.setCartMobile(false)}
                    className="btn-style">
                    <FontAwesomeIcon
                      style={{ width: 16, height: 26 }}
                      icon={faXmark}
                      size="2x"
                      color="#2D3958"
                    />
                  </button>
                </div>

                <Cart
                  restaurantDetail={restaurantDetail}
                  setDeliveryPickupModal={value => store?.userStore?.setDeliveryPickupModal(value)}
                  addressConfirm={addressConfirm}
                  setAddressConfirmModal={() => {
                    setAddressConfirmationModal(true);
                  }}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>

        {addressConfirmationModal && !addressConfirm && (
          <AddressConfirmationModal
            visible={addressConfirmationModal}
            setModal={setAddressConfirmationModal}
            title="Please verify the following order details."
            body="You won’t be able to edit your address or order time once you begin adding items to your cart."
            rightButtonText="Continue"
            leftButtonText="Go back"
            onClickLeftButton={() => setAddressConfirmationModal(false)}
            onClickRightButton={() => {
              const filteredQuery = Object.fromEntries(
                Object.entries(router.query)?.filter(
                  ([key]) => key == 'order_source' || key?.startsWith('utm_')
                )
              );
              setAddressConfirm(true);
              store?.cartStore?.setCartMobile(false);

              router.push({
                pathname: `/checkout/${cart?.data?.attributes?.slug}`,
                query: filteredQuery,
              });
            }}
            restaurantName={restaurantDetail?.attributes?.display_name}
            address={{
              delivery_address: address,
              delivery_date:
                moment(cart?.cartDate).format('dddd, MMMM Do, YYYY') ||
                moment(selectedTime).format('dddd, MMMM Do, YYYY'),
              delivery_time: cart?.cartTime || selectedTime,
            }}
          />
        )}
      </Dialog>
    </Transition>
  );
}

export default observer(CartMobile);
